import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage, routeMapping } from '../context/LanguageContext';
import { translations } from '../data/translations';
import { NewsletterSignup } from './NewsletterSignup';

const FooterBilingual = () => {
  const { language, t } = useLanguage();
  const nav = translations.nav;
  const footer = translations.footer;
  
  const langPrefix = `/${language}`;
  
  const getRoute = (pageKey) => {
    const route = routeMapping[language][pageKey];
    return `${langPrefix}${route ? '/' + route : ''}`;
  };

  return (
    <footer style={{
      background: 'var(--bg-secondary)',
      padding: '80px 0 40px',
      borderTop: '1px solid var(--border-light)'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '60px',
          marginBottom: '60px'
        }}>
          {/* Brand Column */}
          <div>
            <Link to={getRoute('home')} style={{
              display: 'flex',
              flexDirection: 'column',
              textDecoration: 'none',
              lineHeight: 1.1,
              marginBottom: '24px'
            }}>
              <span style={{
                fontSize: '18px',
                fontWeight: 400,
                fontFamily: "'Suisse Regular', 'Helvetica Neue', Helvetica, Arial, sans-serif",
                color: 'var(--text-primary)',
                letterSpacing: '0.25em',
                textTransform: 'uppercase'
              }}>
                Fenicis
              </span>
              <span style={{
                fontSize: '7px',
                fontWeight: 400,
                fontFamily: "'Suisse Regular', 'Helvetica Neue', Helvetica, Arial, sans-serif",
                color: 'var(--text-secondary)',
                letterSpacing: '0.2em',
                textTransform: 'uppercase',
                marginTop: '4px'
              }}>
                Global Hospitality
              </span>
            </Link>
            <p className="body-small" style={{ 
              color: 'var(--text-secondary)',
              marginBottom: '16px'
            }}>
              {t(footer.tagline)}
            </p>
            <p className="body-small" style={{ color: 'var(--text-light)' }}>
              {t(footer.location)}
            </p>
          </div>
          
          {/* Navigation Column */}
          <div>
            <h4 className="meta-text" style={{ 
              marginBottom: '24px',
              color: 'var(--gold-accent)'
            }}>
              Navigation
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link to={getRoute('house')} className="body-small" style={{ 
                textDecoration: 'none',
                color: 'var(--text-secondary)',
                transition: 'color 0.2s ease'
              }}>
                {t(nav.theHouse)}
              </Link>
              <Link to={getRoute('expertise')} className="body-small" style={{ 
                textDecoration: 'none',
                color: 'var(--text-secondary)',
                transition: 'color 0.2s ease'
              }}>
                {t(nav.expertise)}
              </Link>
              <Link to={getRoute('works')} className="body-small" style={{ 
                textDecoration: 'none',
                color: 'var(--text-secondary)',
                transition: 'color 0.2s ease'
              }}>
                {t(nav.selectedWorks)}
              </Link>
              <Link to={getRoute('founder')} className="body-small" style={{ 
                textDecoration: 'none',
                color: 'var(--text-secondary)',
                transition: 'color 0.2s ease'
              }}>
                {t(nav.founder)}
              </Link>
              <Link to={getRoute('contact')} className="body-small" style={{ 
                textDecoration: 'none',
                color: 'var(--text-secondary)',
                transition: 'color 0.2s ease'
              }}>
                {t(nav.contact)}
              </Link>
            </div>
          </div>
          
          {/* Contact Column */}
          <div>
            <h4 className="meta-text" style={{ 
              marginBottom: '24px',
              color: 'var(--gold-accent)'
            }}>
              Contact
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <a href="mailto:nidale.barret@fenicis.com" className="body-small" style={{ 
                textDecoration: 'none',
                color: 'var(--text-secondary)',
                transition: 'color 0.2s ease'
              }}>
                nidale.barret@fenicis.com
              </a>
              <a href="tel:+33625394939" className="body-small" style={{ 
                textDecoration: 'none',
                color: 'var(--text-secondary)',
                transition: 'color 0.2s ease'
              }}>
                +33 6 25 39 49 39
              </a>
              <Link to={getRoute('contact')} className="btn-secondary" style={{
                marginTop: '16px',
                display: 'inline-block',
                textAlign: 'center'
              }}>
                {t(nav.cta)}
              </Link>
            </div>
          </div>
        </div>
        
        <div style={{ borderTop: '1px solid var(--border-light)', padding: '48px 0' }}>
          <NewsletterSignup source="footer" />
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid var(--border-light)',
          paddingTop: '24px',
          textAlign: 'center'
        }}>
          <p style={{ 
            fontSize: '10px',
            color: 'var(--text-light)',
            marginBottom: '16px',
            letterSpacing: '0.02em'
          }}>
            {t(footer.seoLine)}
          </p>
          <p className="body-small" style={{ color: 'var(--text-light)' }}>
            {t(footer.copyright).replace('{year}', new Date().getFullYear())}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterBilingual;
